(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hh-dyn-purchase"] && !Shopify.designMode) return;
  try {
    (function () {
  function setSingleItemDefault(root) {
    if (root.dataset.hhDefaultQuantity === 'done') return;

    var radios = root.querySelectorAll('input.koala-deal__tier__input[type="radio"]');
    if (radios.length < 2) return;

    var selected = Array.prototype.find.call(radios, function (radio) {
      return radio.checked;
    });
    if (!selected) return;

    root.dataset.hhDefaultQuantity = 'done';
    if (selected === radios[0]) return;

    var label = radios[0].nextElementSibling;
    if (label && label.tagName === 'LABEL') {
      label.click();
    } else {
      radios[0].click();
    }
  }

  function scanQuantityBreaks() {
    document.querySelectorAll('.hh-pdp--dynamic koala-quantity-breaks-embed').forEach(setSingleItemDefault);
  }

  function startQuantityDefault() {
    scanQuantityBreaks();
    new MutationObserver(scanQuantityBreaks).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startQuantityDefault, { once: true });
  } else {
    startQuantityDefault();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-images"] && !Shopify.designMode) return;
  try {
    (() => {
    const galleries = new WeakSet();
    const initializeGalleryFocus = () => {
      document.querySelectorAll('[data-product-photos]').forEach((gallery) => {
        if (galleries.has(gallery)) return;
        galleries.add(gallery);
        const syncSlide = (slide) => {
          if (!slide.classList.contains('product-main-slide')) return;
          slide.inert = slide.getAttribute('aria-hidden') === 'true';
        };
        gallery.querySelectorAll('.product-main-slide').forEach(syncSlide);
        const observer = new MutationObserver((records) => {
          records.forEach((record) => syncSlide(record.target));
        });
        observer.observe(gallery, {
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-hidden']
        });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeGalleryFocus, { once: true });
    } else {
      initializeGalleryFocus();
    }
    document.addEventListener('shopify:section:load', initializeGalleryFocus);
  })();
  } catch(e) { console.error(e); }
})();

})();
